export default "__VITE_ASSET__4iOmlB7O__"